import { all } from 'redux-saga/effects';

export default all([]);